import {
  CHANGE_SAVED_SEARCH_DIRECTORY,
  CHANGE_SAVED_SEARCH_DIRECTORY_FAILED,
  CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  CLEAR_REDIRECT_SAVED_SEARCH,
  CLEAR_SAVED_SEARCH_DIRECTORY,
  CLEAR_SAVED_SEARCH_HISTORY,
  CLEAR_SAVED_SEARCH_HISTORY_FAILED,
  CLEAR_SAVED_SEARCH_HISTORY_SUCCESS,
  CREATE_SAVED_SEARCH,
  CREATE_SAVED_SEARCH_DIRECTORY,
  CREATE_SAVED_SEARCH_DIRECTORY_FAILED,
  CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  CREATE_SAVED_SEARCH_FAILED,
  CREATE_SAVED_SEARCH_SUCCESS,
  DELETE_SAVED_SEARCH,
  DELETE_SAVED_SEARCH_DIRECTORY,
  DELETE_SAVED_SEARCH_DIRECTORY_FAILED,
  DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  DELETE_SAVED_SEARCH_FAILED,
  DELETE_SAVED_SEARCH_SUCCESS,
  GET_SAVED_SEARCH,
  GET_SAVED_SEARCH_DIRECTORIES,
  GET_SAVED_SEARCH_DIRECTORIES_FAILED,
  GET_SAVED_SEARCH_DIRECTORIES_SUCCESS,
  GET_SAVED_SEARCH_DIRECTORY,
  GET_SAVED_SEARCH_DIRECTORY_FAILED,
  GET_SAVED_SEARCH_DIRECTORY_SUCCESS,
  GET_SAVED_SEARCH_FAILED,
  GET_SAVED_SEARCH_HISTORY,
  GET_SAVED_SEARCH_HISTORY_FAILED,
  GET_SAVED_SEARCH_HISTORY_SUCCESS,
  GET_SAVED_SEARCH_ID,
  GET_SAVED_SEARCH_ID_FAILED,
  GET_SAVED_SEARCH_ID_SUCCESS,
  GET_SAVED_SEARCH_RECENT,
  GET_SAVED_SEARCH_RECENT_FAILED,
  GET_SAVED_SEARCH_RECENT_SUCCESS,
  GET_SAVED_SEARCH_RESULT,
  GET_SAVED_SEARCH_RESULT_FAILED,
  GET_SAVED_SEARCH_RESULT_SUCCESS,
  GET_SAVED_SEARCH_SUCCESS,
  MOVE_SAVED_SEARCH,
  MOVE_SAVED_SEARCH_FAILED,
  MOVE_SAVED_SEARCH_SUCCESS,
  PATCH_SAVED_SEARCH,
  PATCH_SAVED_SEARCH_FAILED,
  PATCH_SAVED_SEARCH_SUCCESS,
  SET_REDIRECT_SAVED_SEARCH,
} from 'redux/constants/savedSearchConstants';

import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import {
  SavedSearchCreateType,
  SavedSearchDirectoryGetType,
  SavedSearchDirectoryResultType,
  SavedSearchDirectoryType,
  SavedSearchItemType,
  SavedSearchMoveType,
  SavedSearchRequestSuccessType,
  SavedSearchRequestType,
  SavedSearchResultType,
} from 'types/savedSearchType';

export function getSavedSearch(payload: SavedSearchRequestType): ActionType<SavedSearchRequestType> {
  return {
    payload,
    type: GET_SAVED_SEARCH,
  };
}

export function getSavedSearchSuccess(
  payload: SavedSearchRequestSuccessType
): ActionType<SavedSearchRequestSuccessType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_SUCCESS,
  };
}

export function getSavedSearchFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_FAILED,
  };
}

export function getSavedSearchRecent(payload: SavedSearchRequestType): ActionType<SavedSearchRequestType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RECENT,
  };
}

export function getSavedSearchRecentSuccess(
  payload: SavedSearchRequestSuccessType
): ActionType<SavedSearchRequestSuccessType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RECENT_SUCCESS,
  };
}

export function getSavedSearchRecentFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RECENT_FAILED,
  };
}

export function getSavedSearchHistory(payload: SavedSearchRequestType): ActionType<SavedSearchRequestType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_HISTORY,
  };
}

export function getSavedSearchHistorySuccess(
  payload: SavedSearchRequestSuccessType
): ActionType<SavedSearchRequestSuccessType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_HISTORY_SUCCESS,
  };
}

export function getSavedSearchHistoryFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_HISTORY_FAILED,
  };
}

// ------

export function getSavedSearchDirectories(
  payload: SavedSearchDirectoryGetType
): ActionType<SavedSearchDirectoryGetType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORIES,
  };
}

export function getSavedSearchDirectoriesSuccess(
  payload: SavedSearchDirectoryResultType
): ActionType<SavedSearchDirectoryResultType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORIES_SUCCESS,
  };
}

export function getSavedSearchDirectoriesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORIES_FAILED,
  };
}

// ------

export function getSavedSearchDirectory(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORY,
  };
}

export function getSavedSearchDirectorySuccess(
  payload: SavedSearchDirectoryType
): ActionType<SavedSearchDirectoryType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORY_SUCCESS,
  };
}

export function getSavedSearchDirectoryFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_DIRECTORY_FAILED,
  };
}

// ------

export function createSavedSearch(payload: SavedSearchCreateType): ActionType<SavedSearchCreateType> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH,
  };
}

export function createSavedSearchSuccess(payload: SavedSearchItemType): ActionType<SavedSearchItemType> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH_SUCCESS,
  };
}

export function createSavedSearchFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH_FAILED,
  };
}

// -----

export function createSavedSearchDirectory(payload: string): ActionType<string> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH_DIRECTORY,
  };
}

export function createSavedSearchDirectorySuccess(
  payload: SavedSearchDirectoryType
): ActionType<SavedSearchDirectoryType> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  };
}

export function createSavedSearchDirectoryFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: CREATE_SAVED_SEARCH_DIRECTORY_FAILED,
  };
}

// -----

export function changeSavedSearchDirectory(payload: SavedSearchRequestType): ActionType<SavedSearchRequestType> {
  return {
    payload,
    type: CHANGE_SAVED_SEARCH_DIRECTORY,
  };
}

export function changeSavedSearchDirectorySuccess(payload: SavedSearchItemType): ActionType<SavedSearchItemType> {
  return {
    payload,
    type: CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  };
}

export function changeSavedSearchDirectoryFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: CHANGE_SAVED_SEARCH_DIRECTORY_FAILED,
  };
}

// -----

export function deleteSavedSearchDirectory(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_SAVED_SEARCH_DIRECTORY,
  };
}

export function deleteSavedSearchDirectorySuccess(id: string): ActionType<string> {
  return {
    payload: id,
    type: DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  };
}

export function deleteSavedSearchDirectoryFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_SAVED_SEARCH_DIRECTORY_FAILED,
  };
}

// -----

export function getSavedSearchId(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_ID,
  };
}

export function getSavedSearchIdSuccess(payload: SavedSearchItemType): ActionType<SavedSearchItemType> {
  return {
    payload,
    type: GET_SAVED_SEARCH_ID_SUCCESS,
  };
}

export function getSavedSearchIdFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_ID_FAILED,
  };
}

// -----

export function deleteSavedSearch(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_SAVED_SEARCH,
  };
}

export function deleteSavedSearchSuccess(id: string): ActionType<string> {
  return {
    payload: id,
    type: DELETE_SAVED_SEARCH_SUCCESS,
  };
}

export function deleteSavedSearchFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_SAVED_SEARCH_FAILED,
  };
}

// -----

export function patchSavedSearch(payload: SavedSearchCreateType): ActionType<SavedSearchCreateType> {
  return {
    payload,
    type: PATCH_SAVED_SEARCH,
  };
}

export function patchSavedSearchSuccess(): ActionType {
  return {
    payload: null,
    type: PATCH_SAVED_SEARCH_SUCCESS,
  };
}

export function patchSavedSearchFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: PATCH_SAVED_SEARCH_FAILED,
  };
}

// -----

export function moveSavedSearch(payload: SavedSearchMoveType): ActionType<SavedSearchMoveType> {
  return {
    payload,
    type: MOVE_SAVED_SEARCH,
  };
}

export function moveSavedSearchSuccess(payload: string): ActionType<string> {
  return {
    payload,
    type: MOVE_SAVED_SEARCH_SUCCESS,
  };
}

export function moveSavedSearchFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: MOVE_SAVED_SEARCH_FAILED,
  };
}

// -----

export function getSavedSearchResults(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RESULT,
  };
}

export function getSavedSearchResultsSuccess(payload: SavedSearchResultType[]): ActionType<SavedSearchResultType[]> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RESULT_SUCCESS,
  };
}

export function getSavedSearchResultsFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SAVED_SEARCH_RESULT_FAILED,
  };
}

export function setRedirectSavedSearch(): ActionType {
  return {
    payload: null,
    type: SET_REDIRECT_SAVED_SEARCH,
  };
}

export function clearRedirectSavedSearch(): ActionType {
  return {
    payload: null,
    type: CLEAR_REDIRECT_SAVED_SEARCH,
  };
}

export function clearSavedSearchDirectory(): ActionType {
  return {
    payload: null,
    type: CLEAR_SAVED_SEARCH_DIRECTORY,
  };
}

// -----

export function clearSavedSearchHistory(): ActionType {
  return {
    payload: null,
    type: CLEAR_SAVED_SEARCH_HISTORY,
  };
}

export function clearSavedSearchHistorySuccess(): ActionType {
  return {
    payload: null,
    type: CLEAR_SAVED_SEARCH_HISTORY_SUCCESS,
  };
}

export function clearSavedSearchHistoryFailed(payload: string): ActionType<string> {
  return {
    payload,
    type: CLEAR_SAVED_SEARCH_HISTORY_FAILED,
  };
}
